export const isContentStateEmpty = contentState => {
  let result = true;
  if (contentState) {
    const firstBlock = contentState.blocks[0];
    result =
      contentState.blocks.length === 1 && firstBlock.text === '' && firstBlock.type === 'unstyled';
  }
  return result;
};
